import React, { createContext, useContext, useState } from 'react';

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
  const [activeTab,             setActiveTab]             = useState('dashboard');   // 'dashboard' | 'requests' | 'new' | 'profile' | 'notifications'
  const [menuOpen,              setMenuOpen]              = useState(false);
  const [requestModal,          setRequestModal]          = useState(false);
  const [notification,          setNotification]          = useState(null);
  const [preselectedService,    setPreselectedService]    = useState(null); // service object from SERVICES
  const [preselectedRequestId,  setPreselectedRequestId]  = useState(null); // deep-link target from a notification
  const [preselectedTicketId,   setPreselectedTicketId]   = useState(null); // deep-link target from a notification

  const openMenu  = () => setMenuOpen(true);
  const closeMenu = () => setMenuOpen(false);

  const showNotification = (msg, type = 'success') => {
    setNotification({ msg, type });
    setTimeout(() => setNotification(null), 3000);
  };

  return (
    <AppContext.Provider value={{
      activeTab, setActiveTab,
      menuOpen, openMenu, closeMenu,
      requestModal, setRequestModal,
      notification, showNotification,
      preselectedService, setPreselectedService,
      preselectedRequestId, setPreselectedRequestId,
      preselectedTicketId,  setPreselectedTicketId,
    }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error('useApp must be used within AppProvider');
  return ctx;
};
